import { SERVICE_CONTRACT_TYPES, TRANSPORT_OPTION_TYPES } from '@common/utils'

export const INITIAL_STATE = {
  selectedTransportType: TRANSPORT_OPTION_TYPES.DELIVERY,
  builderHeaderDistanceToTop: 0,
  activeStep: 0,
  archivedFactoryFits: [],
  dealerFitsChecked: false,
  expandedFamilies: new Set<string>(),
  factoryFitsChecked: false,
  useBrandWarranty: false,
  rulesToBeApplied: undefined,
  selectedDealerOptions: [],
  sectionsErrors: {
    serviceContract: false,
    transportOption: false,
    warranty: false
  },
  selectedServiceContract: SERVICE_CONTRACT_TYPES.NONE
} as const
